import { useQuery } from "@apollo/client";
import React, { useState } from "react";
import { FAILED_EMAILS } from "@/api/queries";
import FailedEmailsTable from "@/features/failed-emails/FailedEmailsTable";
import { usePaginatedTableRequest } from '@/components/tables/hooks/usePaginatedTableRequest';

const FailedEmail = () => {
  const {
    data,
    pagination,
    setPagination,
    loading
  } = usePaginatedTableRequest(FAILED_EMAILS)

  return (
    <FailedEmailsTable 
      failedEmails={data?.failedEmails?.items} 
      pagination={pagination}
      setPagination={setPagination}
      totalCount={data?.failedEmails?.totalCount}
      loading={loading}
    />
  );
};

export default FailedEmail;
